import { API, graphqlOperation } from "aws-amplify"

import { getInstrument } from "../../graphql/queries"

export default async function getInstrumentData(nemo: string) {
  try {
    if (nemo === "USDUSD") {
      return "Error al cargar la información del instrumento."
    }
    const result: any = await API.graphql(
      graphqlOperation(getInstrument, {
        nemo,
      })
    )

    return result.data?.getInstrument
  } catch (e) {
    console.error(e)
    return "Error al cargar la información del instrumento."
  }
}
